import { render, staticRenderFns } from "./MetadataDisplay.vue?vue&type=template&id=0fb4e6eb&scoped=true"
import script from "./MetadataDisplay.vue?vue&type=script&lang=js"
export * from "./MetadataDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb4e6eb",
  null
  
)

export default component.exports